(() => {
  if (customElements.get('bc-video-hero')) return;
  class BlackCometVideoHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupIntro();
      this.video = this.querySelector('video');
      if (this.video) { this.video.muted = true; this.video.setAttribute('playsinline', ''); }
      const update = () => {
        const moving = this.visible && !document.hidden && !this.reduced.matches;
        this.classList.toggle('is-motion-active', !!moving);
        if (this.video) {
          if (moving) this.video.play().catch(() => {});
          else this.video.pause();
        }
      };
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; update(); }, { threshold: .05 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', update, { signal: this.controller.signal });
      this.reduced.addEventListener('change', update, { signal: this.controller.signal });
      this.querySelector('[data-bc-explore-services]')?.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(event.currentTarget.href, location.href);
        if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname) return;
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) return;
        event.preventDefault();
        history.pushState(null, '', url.hash);
        target.scrollIntoView({ behavior: this.reduced.matches ? 'auto' : 'smooth', block: 'start' });
      }, { signal: this.controller.signal });
      update();
    }
    setupIntro() {
      this.introDone = this.dataset.introState === 'ready';
      if (this.introDone) { this.classList.add('is-chart-intro-ready'); return; }
      const reveal = () => {
        if (this.introDone) return;
        this.introDone = true;
        clearTimeout(this.introFallback);
        this.dataset.introState = 'ready';
        this.chartIntroTimer = setTimeout(() => this.classList.add('is-chart-intro-ready'), this.reduced.matches ? 0 : 640);
      };
      document.addEventListener('bc:brand-ready', reveal, { signal: this.controller.signal });
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) reveal(); }, { signal: this.controller.signal });
      window.addEventListener('scroll', () => { if (window.scrollY > 40) reveal(); }, { passive: true, signal: this.controller.signal });
      const header = document.querySelector('bc-site-header');
      if (this.reduced.matches || !header || ['revealing','ready'].includes(header.dataset.navIntro)) reveal();
      else this.introFallback = setTimeout(reveal, 4500);
    }
    disconnectedCallback() { clearTimeout(this.introFallback); clearTimeout(this.chartIntroTimer); this.controller?.abort(); this.observer?.disconnect(); this.video?.pause(); this.classList.remove('is-motion-active'); this.controller = null; }
  }
  customElements.define('bc-video-hero', BlackCometVideoHero);
})();
